const TRAVEL_DESTINATION_COUNTRIES = [
  { TRC_SHT_DESC: 'DZ', TRC_NAME: 'ALGERIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'AO', TRC_NAME: 'ANGOLA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'BJ', TRC_NAME: 'BENIN', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'BW', TRC_NAME: 'BOTSWANA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'BF', TRC_NAME: 'BURKINA FASO', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'BI', TRC_NAME: 'BURUNDI', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'CM', TRC_NAME: 'CAMEROON', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'CV', TRC_NAME: 'CAPE VERDE', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'CF', TRC_NAME: 'CENTRAL AFRICAN REPUBLIC', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'TD', TRC_NAME: 'CHAD', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'KM', TRC_NAME: 'COMOROS', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'CG', TRC_NAME: 'CONGO', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'CD', TRC_NAME: 'CONGO (DEMOCRATIC REPUBLIC)', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'CI', TRC_NAME: 'COTE D\'IVOIRE', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'DJ', TRC_NAME: 'DJIBOUTI', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'EG', TRC_NAME: 'EGYPT', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'GQ', TRC_NAME: 'EQUATORIAL GUINEA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'ER', TRC_NAME: 'ERITREA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'ET', TRC_NAME: 'ETHIOPIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'GA', TRC_NAME: 'GABON', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'GM', TRC_NAME: 'GAMBIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'GH', TRC_NAME: 'GHANA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'GN', TRC_NAME: 'GUINEA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'GW', TRC_NAME: 'GUINEA-BISSAU', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'KE', TRC_NAME: 'KENYA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'LS', TRC_NAME: 'LESOTHO', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'LR', TRC_NAME: 'LIBERIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'LY', TRC_NAME: 'LIBYA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'MG', TRC_NAME: 'MADAGASCAR', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'MW', TRC_NAME: 'MALAWI', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'ML', TRC_NAME: 'MALI', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'MR', TRC_NAME: 'MAURITANIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'MU', TRC_NAME: 'MAURITIUS', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'YT', TRC_NAME: 'MAYOTTE', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'MA', TRC_NAME: 'MOROCCO', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'MZ', TRC_NAME: 'MOZAMBIQUE', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'NA', TRC_NAME: 'NAMIBIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'NE', TRC_NAME: 'NIGER', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'NG', TRC_NAME: 'NIGERIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'RE', TRC_NAME: 'REUNION', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'RW', TRC_NAME: 'RWANDA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'ST', TRC_NAME: 'SAO TOME AND PRINCIPE', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'SN', TRC_NAME: 'SENEGAL', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'SC', TRC_NAME: 'SEYCHELLES', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'SL', TRC_NAME: 'SIERRA LEONE', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'SO', TRC_NAME: 'SOMALIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'ZA', TRC_NAME: 'SOUTH AFRICA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'SS', TRC_NAME: 'SOUTH SUDAN', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'SD', TRC_NAME: 'SUDAN', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'SZ', TRC_NAME: 'ESWATINI (SWAZILAND)', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'TZ', TRC_NAME: 'TANZANIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'TG', TRC_NAME: 'TOGO', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'TN', TRC_NAME: 'TUNISIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'UG', TRC_NAME: 'UGANDA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'ZM', TRC_NAME: 'ZAMBIA', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'ZW', TRC_NAME: 'ZIMBABWE', TRC_TRZ_CODE: 1 },
  { TRC_SHT_DESC: 'AF', TRC_NAME: 'AFGHANISTAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'AM', TRC_NAME: 'ARMENIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'AZ', TRC_NAME: 'AZERBAIJAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'BH', TRC_NAME: 'BAHRAIN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'BD', TRC_NAME: 'BANGLADESH', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'BT', TRC_NAME: 'BHUTAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'BN', TRC_NAME: 'BRUNEI', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'KH', TRC_NAME: 'CAMBODIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'CN', TRC_NAME: 'CHINA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'GE', TRC_NAME: 'GEORGIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'HK', TRC_NAME: 'HONG KONG', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'IN', TRC_NAME: 'INDIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'ID', TRC_NAME: 'INDONESIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'IR', TRC_NAME: 'IRAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'IQ', TRC_NAME: 'IRAQ', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'IL', TRC_NAME: 'ISRAEL', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'JP', TRC_NAME: 'JAPAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'JO', TRC_NAME: 'JORDAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'KZ', TRC_NAME: 'KAZAKHSTAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'KW', TRC_NAME: 'KUWAIT', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'KG', TRC_NAME: 'KYRGYZSTAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'LA', TRC_NAME: 'LAOS', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'LB', TRC_NAME: 'LEBANON', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'MO', TRC_NAME: 'MACAU', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'MY', TRC_NAME: 'MALAYSIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'MV', TRC_NAME: 'MALDIVES', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'MN', TRC_NAME: 'MONGOLIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'MM', TRC_NAME: 'MYANMAR (BURMA)', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'NP', TRC_NAME: 'NEPAL', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'KP', TRC_NAME: 'NORTH KOREA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'OM', TRC_NAME: 'OMAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'PK', TRC_NAME: 'PAKISTAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'PS', TRC_NAME: 'PALESTINE', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'PH', TRC_NAME: 'PHILIPPINES', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'QA', TRC_NAME: 'QATAR', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'SA', TRC_NAME: 'SAUDI ARABIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'SG', TRC_NAME: 'SINGAPORE', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'KR', TRC_NAME: 'SOUTH KOREA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'LK', TRC_NAME: 'SRI LANKA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'SY', TRC_NAME: 'SYRIA', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'TW', TRC_NAME: 'TAIWAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'TJ', TRC_NAME: 'TAJIKISTAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'TH', TRC_NAME: 'THAILAND', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'TL', TRC_NAME: 'TIMOR-LESTE', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'TR', TRC_NAME: 'TURKEY', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'TM', TRC_NAME: 'TURKMENISTAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'AE', TRC_NAME: 'UNITED ARAB EMIRATES', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'UZ', TRC_NAME: 'UZBEKISTAN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'VN', TRC_NAME: 'VIETNAM', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'YE', TRC_NAME: 'YEMEN', TRC_TRZ_CODE: 2 },
  { TRC_SHT_DESC: 'US', TRC_NAME: 'UNITED STATES', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'CA', TRC_NAME: 'CANADA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'MX', TRC_NAME: 'MEXICO', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'BZ', TRC_NAME: 'BELIZE', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'CR', TRC_NAME: 'COSTA RICA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'SV', TRC_NAME: 'EL SALVADOR', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'GT', TRC_NAME: 'GUATEMALA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'HN', TRC_NAME: 'HONDURAS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'NI', TRC_NAME: 'NICARAGUA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'PA', TRC_NAME: 'PANAMA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'AI', TRC_NAME: 'ANGUILLA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'AG', TRC_NAME: 'ANTIGUA AND BARBUDA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'AW', TRC_NAME: 'ARUBA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'BS', TRC_NAME: 'BAHAMAS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'BB', TRC_NAME: 'BARBADOS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'BM', TRC_NAME: 'BERMUDA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'VG', TRC_NAME: 'BRITISH VIRGIN ISLANDS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'KY', TRC_NAME: 'CAYMAN ISLANDS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'CU', TRC_NAME: 'CUBA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'CW', TRC_NAME: 'CURACAO', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'DM', TRC_NAME: 'DOMINICA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'DO', TRC_NAME: 'DOMINICAN REPUBLIC', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'GD', TRC_NAME: 'GRENADA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'GP', TRC_NAME: 'GUADELOUPE', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'HT', TRC_NAME: 'HAITI', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'JM', TRC_NAME: 'JAMAICA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'MQ', TRC_NAME: 'MARTINIQUE', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'MS', TRC_NAME: 'MONTSERRAT', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'PR', TRC_NAME: 'PUERTO RICO', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'KN', TRC_NAME: 'SAINT KITTS AND NEVIS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'LC', TRC_NAME: 'SAINT LUCIA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'VC', TRC_NAME: 'SAINT VINCENT AND THE GRENADINES', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'TT', TRC_NAME: 'TRINIDAD AND TOBAGO', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'TC', TRC_NAME: 'TURKS AND CAICOS ISLANDS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'VI', TRC_NAME: 'US VIRGIN ISLANDS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'AR', TRC_NAME: 'ARGENTINA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'BO', TRC_NAME: 'BOLIVIA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'BR', TRC_NAME: 'BRAZIL', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'CL', TRC_NAME: 'CHILE', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'CO', TRC_NAME: 'COLOMBIA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'EC', TRC_NAME: 'ECUADOR', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'FK', TRC_NAME: 'FALKLAND ISLANDS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'GF', TRC_NAME: 'FRENCH GUIANA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'GY', TRC_NAME: 'GUYANA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'PY', TRC_NAME: 'PARAGUAY', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'PE', TRC_NAME: 'PERU', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'SR', TRC_NAME: 'SURINAME', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'UY', TRC_NAME: 'URUGUAY', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'VE', TRC_NAME: 'VENEZUELA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'AU', TRC_NAME: 'AUSTRALIA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'NZ', TRC_NAME: 'NEW ZEALAND', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'FJ', TRC_NAME: 'FIJI', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'PG', TRC_NAME: 'PAPUA NEW GUINEA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'NC', TRC_NAME: 'NEW CALEDONIA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'PF', TRC_NAME: 'FRENCH POLYNESIA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'SB', TRC_NAME: 'SOLOMON ISLANDS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'VU', TRC_NAME: 'VANUATU', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'WS', TRC_NAME: 'SAMOA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'TO', TRC_NAME: 'TONGA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'CK', TRC_NAME: 'COOK ISLANDS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'PW', TRC_NAME: 'PALAU', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'MH', TRC_NAME: 'MARSHALL ISLANDS', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'FM', TRC_NAME: 'MICRONESIA', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'KI', TRC_NAME: 'KIRIBATI', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'TV', TRC_NAME: 'TUVALU', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'NR', TRC_NAME: 'NAURU', TRC_TRZ_CODE: 3 },
  { TRC_SHT_DESC: 'AL', TRC_NAME: 'ALBANIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'AD', TRC_NAME: 'ANDORRA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'AT', TRC_NAME: 'AUSTRIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'BY', TRC_NAME: 'BELARUS', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'BE', TRC_NAME: 'BELGIUM', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'BA', TRC_NAME: 'BOSNIA AND HERZEGOVINA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'BG', TRC_NAME: 'BULGARIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'HR', TRC_NAME: 'CROATIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'CY', TRC_NAME: 'CYPRUS', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'CZ', TRC_NAME: 'CZECH REPUBLIC', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'DK', TRC_NAME: 'DENMARK', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'EE', TRC_NAME: 'ESTONIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'FI', TRC_NAME: 'FINLAND', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'FR', TRC_NAME: 'FRANCE', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'DE', TRC_NAME: 'GERMANY', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'GI', TRC_NAME: 'GIBRALTAR', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'GR', TRC_NAME: 'GREECE', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'HU', TRC_NAME: 'HUNGARY', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'IS', TRC_NAME: 'ICELAND', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'IE', TRC_NAME: 'IRELAND', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'IT', TRC_NAME: 'ITALY', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'XK', TRC_NAME: 'KOSOVO', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'LV', TRC_NAME: 'LATVIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'LI', TRC_NAME: 'LIECHTENSTEIN', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'LT', TRC_NAME: 'LITHUANIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'LU', TRC_NAME: 'LUXEMBOURG', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'MT', TRC_NAME: 'MALTA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'MD', TRC_NAME: 'MOLDOVA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'MC', TRC_NAME: 'MONACO', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'ME', TRC_NAME: 'MONTENEGRO', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'NL', TRC_NAME: 'NETHERLANDS', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'MK', TRC_NAME: 'NORTH MACEDONIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'NO', TRC_NAME: 'NORWAY', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'PL', TRC_NAME: 'POLAND', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'PT', TRC_NAME: 'PORTUGAL', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'RO', TRC_NAME: 'ROMANIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'RU', TRC_NAME: 'RUSSIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'SM', TRC_NAME: 'SAN MARINO', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'RS', TRC_NAME: 'SERBIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'SK', TRC_NAME: 'SLOVAKIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'SI', TRC_NAME: 'SLOVENIA', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'ES', TRC_NAME: 'SPAIN', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'SE', TRC_NAME: 'SWEDEN', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'CH', TRC_NAME: 'SWITZERLAND', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'UA', TRC_NAME: 'UKRAINE', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'GB', TRC_NAME: 'UNITED KINGDOM', TRC_TRZ_CODE: 4 },
  { TRC_SHT_DESC: 'VA', TRC_NAME: 'VATICAN CITY', TRC_TRZ_CODE: 4 },
];

export default TRAVEL_DESTINATION_COUNTRIES;
